// Never delete this export, this is used to validate themes!
const AvailableThemes = ['theme-default', 'theme-hhn'];
// gds image data-model keys
const GdsImageKeys = [
  'image',
  'avatarImage',
  'iconImage',
  'mapImage',
  'heroImage',
  'logoImage',
  'backgroundImage',
  'floatingImage',
  'floatingImageLeft',
  'floatingImageRight',
];
/*
 *	the following land-brand colors are used to
 *	differentiate for dark-font on land-hero component
 */
const DarkFontLandBrandColors = [
  'uor.ueu.p903',
  'uor.usf.kidzone',
  'uor.usf.springfield-home-of-the-simpsons',
  'uor.ioa.seuss-landing',
  'uor.vb.rainforest-village',
  'uor.vb.the-volcano',
  'uor.vb.wave-village',
  'ush.illumination-land',
  'ush.springfield-home-of-the-simpsons',
  'ush.transformers-metrobase',
  'usj.minion-park',
  'usj.universal-wonderland',
  'usj.waterworld',
];

export { AvailableThemes as A, DarkFontLandBrandColors as D, GdsImageKeys as G };

